import React from "react";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function GridEmpresas(props) {
    const { arrayEmpresas, clickDelete, userPermissions } = props;

    // Função auxiliar para formatar data e hora
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (!arrayEmpresas || arrayEmpresas.length === 0) {
        return (
            <div className="empty-state text-center p-5">
                <div className="empty-icon mb-3" style={{ fontSize: '3rem', color: '#dee2e6' }}>
                    <i className="fas fa-building"></i>
                </div>
                <h5 className="empty-title text-muted">Nenhuma empresa encontrada</h5>
                <p className="text-muted small">
                    Não há empresas cadastradas ou que correspondam aos critérios da sua pesquisa.
                </p>
            </div>
        );
    }

    return (
        <div className="marcas-grid-container">
            <table className="table-custom">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '100px' }}>Ações</th>
                        <th className="text-start col-nome-razao">Nome / Razão Social</th>
                        <th className="text-start col-nome-fantasia">Nome Fantasia</th>
                        <th className="text-start col-cnpj">CPF/CNPJ</th>
                        <th className="text-start col-cidade">Cidade</th>
                        <th className="text-start col-uf">UF</th>
                        <th className="text-start col-telefone">Telefone</th>
                        <th className="text-start" style={{ minWidth: '120px' }}>Data Cadastro</th>
                        <th className="text-start" style={{ minWidth: '150px' }}>Usuário Cadastro</th>
                        <th className="text-start" style={{ minWidth: '120px' }}>Data Últ. Alt.</th>
                        <th className="text-start" style={{ minWidth: '150px' }}>Usuário Últ. Alt.</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayEmpresas.map((empresa) => (
                        <tr key={empresa.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <Link
                                        to={`/app/editarempresa/${empresa.id}`}
                                        className="btn-action-sm btn-edit"
                                        title="Editar"
                                        onClick={(e) => {
                                            // Validation for Edit
                                            if (userPermissions && userPermissions['editar_empresas'] === false) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                    <button onClick={() => clickDelete(empresa.id)} className="btn-action-sm btn-delete" title="Excluir">
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td className="col-nome-razao" data-label="Nome / Razão Social">
                                <div className="d-flex flex-column">
                                    <span className="fw-medium">{empresa.nome}</span>
                                    <div className="d-flex flex-wrap gap-1 mt-1">
                                        {empresa.is_cliente && <span className="badge-custom badge-subtle-info">Cliente</span>}
                                        {empresa.is_fornecedor && <span className="badge-custom badge-subtle-primary">Forn.</span>}
                                        {empresa.is_transportadora && <span className="badge-custom badge-subtle-success">Transp.</span>}
                                        {empresa.is_terceiro && <span className="badge-custom badge-subtle-warning">Terceiro</span>}
                                    </div>
                                </div>
                            </td>
                            <td className="col-nome-fantasia" data-label="Nome Fantasia">{empresa.nome_fantasia || '-'}</td>
                            <td className="col-cnpj" data-label="CPF/CNPJ">{empresa.cpf_cnpj || '-'}</td>
                            <td className="col-cidade" data-label="Cidade">{empresa.cidade || '-'}</td>
                            <td className="col-uf" data-label="UF">{empresa.uf || '-'}</td>
                            <td className="col-telefone" data-label="Telefone">{empresa.telefone || '-'}</td>
                            <td data-label="Data Cadastro" style={{ minWidth: '120px' }}>{formatDate(empresa.data_cadastro)}</td>
                            <td data-label="Usuário Cadastro" style={{ minWidth: '150px' }}>{empresa.usuario_cadastro || '-'}</td>
                            <td data-label="Data Últ. Alt." style={{ minWidth: '120px' }}>{formatDate(empresa.data_ultima_alteracao)}</td>
                            <td data-label="Usuário Últ. Alt." style={{ minWidth: '150px' }}>{empresa.usuario_ultima_alteracao || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GridEmpresas;